
import { Loader2 } from "lucide-react";

export const FunnelLoading = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white">
    <Loader2 className="h-8 w-8 animate-spin text-slate-600" />
  </div>
);

export const FunnelNotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white">
    <p className="text-lg text-gray-500">Funnel not found</p>
  </div>
);
